import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { BaseService } from '../base/base.service';
import { SessionUserHashManagerService } from '../session-user-hash-manager/session-user-hash-manager.service';

@Injectable({
  providedIn: 'root'
})
export class FaqService extends BaseService {

  private endpoint: string = environment.apiUrl;

  constructor(
    private httpClient: HttpClient,
    protected hashManagerService: SessionUserHashManagerService
    ) { 
      super(hashManagerService);
      this.endpoint += this.endpoint.endsWith("/") ? "" : "/";
    }

  public readFaq(area: string, issue: string) {
    // return this.httpClient.post(this.endpoint + 'api/Students/SendSignUpEmail', 
    // { "StudentId": studentId },
    // this.prepareOptions()).pipe(
    //   map((data: any) => {
        
    //     if (data.status === 299) {
    //       throw {
    //         message: data.body,
    //         status: data.status
    //       };
    //     } else {
    //       return data.body;
    //     }
    //   }), catchError(this.handleError('sendSignUpEmail'))
    // );

    let faqList = [
      {
        title: "FAQ title 1", 
        order: 1, 
        subjects: [
          {type: "Text", order: 1, body: "this is the body of the subject" },
          {type: "Subtitle", order: 2, body: "this is the body of the subject" },
          {type: "Video", order: 3, body: "this is the body of the subject" },
        ]
      },
      {
        title: "FAQ title 2", 
        order: 2, 
        subjects: [
          {type: "Subtitle", order: 1, body: "this is the body of the subject 2" },
          {type: "Text", order: 2, body: "this is the body of the subject 2" },
          {type: "Image", order: 3, body: "this is the body of the subject 2" },
        ]
      },
      {
        title: "FAQ title 3", 
        order: 3, 
        subjects: [
          {type: "Text", order: 1, body: "this is the body of the subject 3" },
          {type: "Text", order: 2, body: "this is the body of the subject 3" },
          {type: "Image", order: 3, body: "this is the body of the subject 3" },
        ]
      },
  ]

    return of(faqList);
  }

}
